/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createEqualScalar } from '../../factoriesAny.js';
export var equalScalarDependencies = {
  typedDependencies: typedDependencies,
  createEqualScalar: createEqualScalar
};